import styled from "styled-components";
import { ColorPaletteOptions } from "../../../../../types/theming";

import CardBase from "../../CardBase";
import { StyledSignatureCardProps } from "./SignatureCard.types";

export const StyledSignatureCard = styled(
	({
		backgroundColor,
		backgroundPatternColor,
		...props
	}: StyledSignatureCardProps) => <CardBase {...props} />
)<StyledSignatureCardProps>`
	${({ theme, backgroundColor, backgroundPatternColor }) => {
		const bgColorArray = backgroundColor.split(" ") as ColorPaletteOptions[];

		const COLOR_BG = theme.palette.hexFor(bgColorArray[0]);
		const COLOR_PATTERN = theme.palette.hexFor(backgroundPatternColor);

		const COLOR_GRADIENT_START = theme.palette.hexFor(bgColorArray[0]);
		const COLOR_GRADIENT_END = theme.palette.hexFor(bgColorArray[1]);
		const GRADIENT = `linear-gradient(180deg, ${COLOR_GRADIENT_START} 0%, ${COLOR_GRADIENT_END} 100%);`;

		const SKEW_DEG = -15;
		const CARD_BORDER_RAD_PX = "60px";
		const SHAPE_BORDER_RAD_PX = "100px";
		const SHAPE_HEIGHT = 75; // %

		return {
			display: "flex",
			position: "relative",
			boxSizing: "border-box",

			minHeight: "420px",
			borderRadius: CARD_BORDER_RAD_PX,

			alignItems: "center",
			clipPath: `inset(0 0 0 0 round ${CARD_BORDER_RAD_PX})`,
			overflow: "hidden",
			background: bgColorArray.length === 2 ? GRADIENT : COLOR_BG,

			...(backgroundPatternColor && {
				"::before, ::after": {
					content: `""`,
					color: "transparent",
					position: "absolute",
					height: `${SHAPE_HEIGHT}%`,
					width: "50%",
					backgroundColor: COLOR_PATTERN,
					opacity: ".07",
					transform: `skew(${SKEW_DEG}deg)`,
					transition: "transform .5s;",
				},

				"::before": {
					top: "0",
					left: `${
						Math.round(SHAPE_HEIGHT * Math.tan((SKEW_DEG * Math.PI) / 180)) / 2
					}%`,
					borderRadius: `0 0 ${SHAPE_BORDER_RAD_PX} 0`,
				},

				"::after": {
					bottom: "0",
					right: `${
						Math.round(SHAPE_HEIGHT * Math.tan((SKEW_DEG * Math.PI) / 180)) / 2
					}%`,
					borderRadius: `${SHAPE_BORDER_RAD_PX} 0 0 0`,
					transform: "skew(-15deg) translate(0, 200px)",
				},
			}),
		};
	}}
`;
